import React from 'react';

const FinancialSection = ({ 
  job,
  formData,
  setFormData,
  handleChange,
  canSeeFinancialFields
}) => {


  if (!canSeeFinancialFields()) {
    return null;
  }

  // Helper to check if we should show property financial defaults
  const shouldShowPropertyDefaults = () => {
    return job.serviceType?.category === 'CLEANING' || job.serviceType?.usePropertyFinancialFields === true;
  };

  return (
    <div className="mt-4 border-t border-gray-200 pt-4">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-gray-700">Financial Information</span>
        <button
          type="button"
          onClick={() => {
            setFormData(prev => ({ ...prev, showFinancialFields: !prev.showFinancialFields }));
          }}
          className="inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500"
        >
          {formData.showFinancialFields ? 'Hide Financial Fields' : 'Show Financial Fields'}
        </button>
      </div>
      
      {formData.showFinancialFields && (
        <div className="mt-3 space-y-3">
          {/* Debug info - only show in development */}
          {process.env.NODE_ENV === 'development' && (
            <div className="text-xs text-gray-500 mb-2">
              <div>Category: {job.serviceType?.category || job.category}</div>
              <div>Property payout: {job.property?.payout ? `$${parseFloat(job.property.payout).toFixed(2)}` : 'Not set'}</div>
              <div>Property price: {job.property?.price ? `$${parseFloat(job.property.price).toFixed(2)}` : 'Not set'}</div>
            </div>
          )}
          
          <div>
            <div className="flex items-center justify-between">
              <label htmlFor="payout" className="block text-sm font-medium text-gray-700">
                Payout Amount ($)
              </label>
              {shouldShowPropertyDefaults() && job.property?.payout && (
                <span className="text-xs text-gray-500">
                  Property default: ${typeof job.property.payout === 'number' ? 
                    job.property.payout.toFixed(2) : 
                    Number(job.property.payout).toFixed(2)}
                </span>
              )}
            </div>
            <div className="relative">
              <input
                type="number"
                step="0.01"
                name="payout"
                id="payout"
                value={formData.payout}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-600 p-2 rounded-md shadow-sm focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                placeholder="0.00"
              />
              {shouldShowPropertyDefaults() && job.property?.payout && (
                <button 
                  type="button"
                  onClick={() => {
                    const payoutValue = typeof job.property.payout === 'number' ? 
                      job.property.payout : Number(job.property.payout);
                    setFormData(prev => ({ ...prev, payout: payoutValue.toString() }));
                  }}
                  className="absolute right-2 top-2.5 text-xs text-sky-600 hover:text-sky-800"
                >
                  Use default
                </button>
              )}
            </div>
          </div>
          
          <div>
            <div className="flex items-center justify-between">
              <label htmlFor="billedAmount" className="block text-sm font-medium text-gray-700">
                Billed Amount ($)
              </label>
              {shouldShowPropertyDefaults() && job.property?.price && (
                <span className="text-xs text-gray-500">
                  Property default: ${typeof job.property.price === 'number' ? 
                    job.property.price.toFixed(2) : 
                    Number(job.property.price).toFixed(2)}
                </span>
              )}
            </div>
            <div className="relative">
              <input
                type="number"
                step="0.01"
                name="billedAmount"
                id="billedAmount"
                value={formData.billedAmount}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-600 p-2 rounded-md shadow-sm focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                placeholder="0.00"
              />
              {shouldShowPropertyDefaults() && job.property?.price && (
                <button 
                  type="button"
                  onClick={() => {
                    const priceValue = typeof job.property.price === 'number' ? 
                      job.property.price : Number(job.property.price);
                    setFormData(prev => ({ ...prev, billedAmount: priceValue.toString() }));
                  }}
                  className="absolute right-2 top-2.5 text-xs text-sky-600 hover:text-sky-800"
                >
                  Use default
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FinancialSection;